module.exports = "<form class=tableFilterModal> {%= groupList %} </form>";


//////////////////
// WEBPACK FOOTER
// ./src/components/WidgetEngine/html/filterHtml/filterModalBody.html
// module id = 1127
// module chunks = 1